import { faSliders } from '@fortawesome/pro-regular-svg-icons';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from 'framework/Icon';

import { Card } from 'components/cards/Card';

import cn from './StrategyTriggers.module.scss';

export const StrategyTriggers = () => {
  return (
    <Card padding="0px" minWidth="350px" maxWidth="350px" direction="column">
      <div className={cn.toolbar}>
        <p>Triggers</p>
        <Icon icon={faSliders} />
      </div>
      <div className={cn.content}>
        <div className={cn.spread}>
          <p className={cn.label}>Signals</p>
          <p className={cn.value}>12</p>
          <p className={cn.label}>Win Rate %</p>
          <p className={cn.value}>85%</p>
          <p className={cn.label}>Cumulative Return</p>
          <p className={cn.value}>134%</p>
        </div>
      </div>
      <div className={cn.direction}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 12px',
          }}
        >
          <div>
            <p>44</p>
            <span className={cn.small}>Signals</span>
          </div>
          <div>
            <p>100%</p>
            <span className={cn.small}>Activation</span>
          </div>
          <div>
            <p>85%</p>
            <span className={cn.small}>Win Rate</span>
          </div>
          <div>
            <p>85%</p>
            <span className={cn.small}>Profit Factor</span>
          </div>
        </div>
        <div className={cn.conditions}>
          <p>Conditions</p>
          <Icon icon={faChevronRight} width="30px" />
        </div>
      </div>
    </Card>
  );
};
